import UnidentifiedChats from './views/UnidentifiedChats'

export function createRoutes() {
  return [
    {
      path: 'unidentified/',
      name: 'tg-chats-unidentified',
      component: UnidentifiedChats,
    },
  ]
}